import { defineMessages } from 'react-intl';
const i18nKey = 'IndividualsTab';
const messages = defineMessages({
  individualsTitle: {
    id: `${i18nKey}.individualsTitle`,
    defaultMessage: 'Wallet is now on web',
    description: `
    #Component: TextHeadline
    #CharLimit: 65
    #Context: Title for products for individuals section`
  },
  individualsDescription: {
    id: `${i18nKey}.individualsDescription`,
    defaultMessage: 'Buy, swap, send, stake, and mint easily.',
    description: `
    #Component: TextLabel2
    #CharLimit: 125
    #Context: Description of products for individuals`
  },
  individualsIndiaDescription: {
    id: `${i18nKey}.individualsIndiaDescription`,
    defaultMessage: "Buy, sell, and trade crypto on the world's most trusted crypto exchange",
    description: `
    #Component: LEGACY
    #CharLimit: 125
    #Context: Description of products for individuals (CharLimit autocalculated to 125)`
  },
  individualsLinkText: {
    id: `${i18nKey}.individualsLinkText`,
    defaultMessage: 'Launch Wallet web app',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Link to launch Wallet web app`
  },
  mobileNavBarLinkText: {
    id: `${i18nKey}.mobileNavBarLinkText`,
    defaultMessage: 'See all',
    description: `
    #Component: Button
    #CharLimit: 50
    #Context: Navbar link text for mobile`
  },
  trade: {
    id: `${i18nKey}.trade`,
    defaultMessage: 'Buy and sell',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Trade product label (CharLimit autocalculated to 45)`
  },
  tradeDescription: {
    id: `${i18nKey}.tradeDescription`,
    defaultMessage: 'Buy, sell, and use crypto',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Trade product description (CharLimit autocalculated to 60)`
  },
  advancedTrade: {
    id: `${i18nKey}.advancedTrade`,
    defaultMessage: 'Advanced',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Advanced trade product label (CharLimit autocalculated to 40)`
  },
  advancedTradeDescription: {
    id: `${i18nKey}.advancedTradeDescription`,
    defaultMessage: 'Professional-grade trading tools',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Advanced Trade product description (CharLimit autocalculated to 60)`
  },
  wallet: {
    id: `${i18nKey}.wallet`,
    defaultMessage: 'Wallet',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Wallet product label (CharLimit autocalculated to 40)`
  },
  walletDescription: {
    id: `${i18nKey}.walletDescription`,
    defaultMessage: 'The best self-hosted crypto wallet',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Wallet product description (CharLimit autocalculated to 75)`
  },
  learningRewards: {
    id: `${i18nKey}.learningRewards`,
    defaultMessage: 'Learning rewards',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Learning rewards product label (CharLimit autocalculated to 50)`
  },
  earn: {
    id: `${i18nKey}.earn`,
    defaultMessage: 'Earn',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: Earn product label (CharLimit autocalculated to 35)`
  },
  earnDescription: {
    id: `${i18nKey}.earnDescription`,
    defaultMessage: 'Receive crypto for completing tasks',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Earn product description (CharLimit autocalculated to 60)`
  },
  newEarnDescription: {
    id: `${i18nKey}.newEarnDescription`,
    defaultMessage: 'Stake your crypto and earn rewards',
    description: `
    #Component: Link
    #CharLimit: 65
    #Context: Earn product description (CharLimit autocalculated to 65)`
  },
  card: {
    id: `${i18nKey}.card`,
    defaultMessage: 'Card',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: Card product label (CharLimit autocalculated to 35)`
  },
  cardDescription: {
    id: `${i18nKey}.cardDescription`,
    defaultMessage: 'Spend crypto, get crypto back',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Card product description (CharLimit autocalculated to 75)`
  },
  privateClient: {
    id: `${i18nKey}.privateClient`,
    defaultMessage: 'Private Client',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Private Client product label (CharLimit autocalculated to 50)`
  },
  privateClientDescription: {
    id: `${i18nKey}.privateClientDescription`,
    defaultMessage: 'For trusts, family offices, UHNWIs',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Private Client product description (CharLimit autocalculated to 75)`
  },
  borrow: {
    id: `${i18nKey}.borrow`,
    defaultMessage: 'Borrow',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Borrow product label (CharLimit autocalculated to 40)`
  },
  borrowDescription: {
    id: `${i18nKey}.borrowDescription`,
    defaultMessage: 'Borrow cash using Bitcoin as collateral',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Borrow product description (CharLimit autocalculated to 80)`
  },
  nft: {
    id: `${i18nKey}.nft`,
    defaultMessage: 'NFT',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: NFT product label (CharLimit autocalculated to 35)`
  },
  nftDescription: {
    id: `${i18nKey}.nftDescription`,
    defaultMessage: 'Create, collect, connect',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: NFT product description (CharLimit autocalculated to 60)`
  },
  coinbaseOne: {
    id: `${i18nKey}.coinbaseOne`,
    defaultMessage: 'Coinbase One',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Coinbase One product label (CharLimit autocalculated to 45)`
  },
  coinbaseOneDescription: {
    id: `${i18nKey}.coinbaseOneDescription`,
    defaultMessage: 'Get zero trading fees and more',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Coinbase One product description (CharLimit autocalculated to 60)`
  },
  learn: {
    id: `${i18nKey}.learn`,
    defaultMessage: 'Learn',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: Learn product label`
  },
  learnDescription: {
    id: `${i18nKey}.learnDescription`,
    defaultMessage: 'Crypto tips and guides',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Learn product description`
  },
  // Link titles
  learningRewardsLinkTitle: {
    id: `${i18nKey}.learningRewardsLinkTitle`,
    // Note: We intentionally use learning rewards as lowercase here. Product/Content requested this as it is in the middle of a sentence and is a functionality, rather than an independent product for retail users.
    defaultMessage: 'Coinbase learning rewards - Receive crypto for completing tasks',
    description: `
    #Component: Link
    #CharLimit: 110
    #Context: Learning rewards link title (CharLimit autocalculated to 110)`
  },
  earnLinkTitle: {
    id: `${i18nKey}.earnLinkTitle`,
    defaultMessage: 'Coinbase Earn - Stake your crypto and earn rewards',
    description: `
    #Component: Link
    #CharLimit: 90
    #Context: earn link title (CharLimit autocalculated to 90)`
  },
  tradeLinkTitle: {
    id: `${i18nKey}.tradeLinkTitle`,
    defaultMessage: 'Buy, sell, and use crypto',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Signup link title (CharLimit autocalculated to 55)`
  },
  advancedTradeLinkTitle: {
    id: `${i18nKey}.advancedTradeLinkTitle`,
    defaultMessage: 'Coinbase Advanced – Professional-grade trading tools',
    description: `
    #Component: Link
    #CharLimit: 105
    #Context: Advanced trade product link title (CharLimit autocalculated to 105)`
  },
  cardLinkTitle: {
    id: `${i18nKey}.cardLinkTitle`,
    defaultMessage: 'Coinbase Card - Spend crypto, get crypto back',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Card link title (CharLimit autocalculated to 80)`
  },
  walletLinkTitle: {
    id: `${i18nKey}.walletLinkTitle`,
    defaultMessage: 'Coinbase Wallet - The best self-hosted crypto wallet',
    description: `
    #Component: Link
    #CharLimit: 85
    #Context: Wallet link title (CharLimit autocalculated to 85)`
  },
  privateClientLinkTitle: {
    id: `${i18nKey}.privateClientLinkTitle`,
    defaultMessage: 'Coinbase Private Client - For trusts, family offices, UHNWIs',
    description: `
    #Component: Link
    #CharLimit: 115
    #Context: Private Client link title (CharLimit autocalculated to 115)`
  },
  borrowLinkTitle: {
    id: `${i18nKey}.borrowLinkTitle`,
    defaultMessage: 'Coinbase Borrow - Borrow cash using Bitcoin as collateral',
    description: `
    #Component: Link
    #CharLimit: 105
    #Context: Borrow link title (CharLimit autocalculated to 105)`
  },
  nftLinkTitle: {
    id: `${i18nKey}.nftLinkTitle`,
    defaultMessage: 'Create, collect, connect',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: NFT link title (CharLimit autocalculated to 60)`
  },
  coinbaseOneLinkTitle: {
    id: `${i18nKey}.coinbaseOneLinkTitle`,
    defaultMessage: 'Coinbase One - Get zero trading fees and more',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Coinbase One link title (CharLimit autocalculated to 60)`
  },
  learnLinkTitle: {
    id: `${i18nKey}.learnLinkTitle`,
    defaultMessage: 'Coinbase Learn - Crypto tips and guides',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Learn link title`
  },
  // Icon alt text
  learningRewardsIconAltText: {
    id: `${i18nKey}.learningRewardsIconAltText`,
    defaultMessage: 'Coinbase learning rewards Icon',
    description: `
    #Component: Link
    #CharLimit: 70
    #Context: Alternative info for learning rewards icon image (CharLimit autocalculated to 70)`
  },
  earnIconAltText: {
    id: `${i18nKey}.earnIconAltText`,
    defaultMessage: 'Coinbase Earn Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for earn icon image (CharLimit autocalculated to 55)`
  },
  tradeIconAltText: {
    id: `${i18nKey}.tradeIconAltText`,
    defaultMessage: 'Coinbase Icon',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Alternative info for Signup icon image (CharLimit autocalculated to 45)`
  },
  advancedTradeIconAltText: {
    id: `${i18nKey}.advancedTradeIconAltText`,
    defaultMessage: 'Advanced Trade Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for Advanced Trade icon image (CharLimit autocalculated to 55)`
  },
  cardIconAltText: {
    id: `${i18nKey}.cardIconAltText`,
    defaultMessage: 'Coinbase Card Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for Card icon image (CharLimit autocalculated to 55)`
  },
  walletIconAltText: {
    id: `${i18nKey}.walletIconAltText`,
    defaultMessage: 'Coinbase Wallet Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for Wallet icon image (CharLimit autocalculated to 55)`
  },
  privateClientIconAltText: {
    id: `${i18nKey}.privateClientAltText`,
    defaultMessage: 'Coinbase Private Client Icon',
    description: `
    #Component: Link
    #CharLimit: 65
    #Context: Alternative info for Private Client icon image (CharLimit autocalculated to 65)`
  },
  borrowIconAltText: {
    id: `${i18nKey}.borrowAltText`,
    defaultMessage: 'Coinbase Borrow Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for Borrow icon image (CharLimit autocalculated to 55)`
  },
  nftIconAltText: {
    id: `${i18nKey}.nftIconAltText`,
    defaultMessage: 'Coinbase NFT Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for NFT icon image (CharLimit autocalculated to 55)`
  },
  coinbaseOneIconAltText: {
    id: `${i18nKey}.coinbaseOneIconAltText`,
    defaultMessage: 'Coinbase One Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for Coinbase One icon image (CharLimit autocalculated to 55)`
  },
  web3: {
    id: `${i18nKey}.web3`,
    defaultMessage: 'Onchain',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Title for Web3 onchain tab (CharLimit autocalculated to 40)`
  },
  web3Description: {
    id: `${i18nKey}.web3Description`,
    defaultMessage: 'Dive into the world of onchain apps',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Description on a link to web3 onchain (CharLimit autocalculated to 75)`
  },
  web3LinkTitle: {
    id: `${i18nKey}.web3LinkTitle`,
    defaultMessage: 'Coinbase Onchain - Dive into the world of onchain apps',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Link to web3 onchain (CharLimit autocalculated to 50)`
  },
  web3IconAltText: {
    id: `${i18nKey}.web3IconAltText`,
    defaultMessage: 'Onchain logo',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Onchain Image Alt Description (CharLimit autocalculated to 45)`
  },
  learnIconAltText: {
    id: `${i18nKey}.learnIconAltText`,
    defaultMessage: 'Coinbase Learn Icon',
    description: `
    #Component: Link
    #CharLimit: 70
    #Context: Coinbase Learn alt description`
  }
});
export { messages as default };
//# sourceMappingURL=messages.js.map
